'use strict';

var React = require('react');

var SvgExchangeMajor = function SvgExchangeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.986 12.166a3 3 0 1 1-1.973 0 1.003 1.003 0 0 1-.013-.166v-2.001a3.999 3.999 0 0 0-3.999-3.999h-.587l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414l-1.293 1.293h.587a5.999 5.999 0 0 1 5.999 5.999v2.001c0 .057-.005.112-.014.166zm-14-4.332c.01.054.014.11.014.166v2.001a4 4 0 0 0 3.999 3.999h.587l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414l1.293-1.293h-.587a6 6 0 0 1-5.999-5.999v-2.001c0-.057.005-.112.014-.166a3 3 0 1 1 1.972 0zm.014-2.834a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm14 10a1 1 0 1 0-2.001.001 1 1 0 0 0 2.001-.001z"
  }));
};

exports.SvgExchangeMajor = SvgExchangeMajor;
